module.exports = __webpack_public_path__ + "media/components/src/assets/images/logo-main/logo-eabd15754dd618b2fce4aaa3b05bfaf4.png";